var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33966 13.4006C1.31461 13.4592 1.30809 13.5241 1.32098 13.5865C1.33387 13.649 1.36556 13.706 1.41178 13.7499C1.45801 13.7938 1.51657 13.8226 1.57959 13.8322C1.64261 13.8419 1.70709 13.8321 1.76437 13.8041L13.0339 8.27979C13.0872 8.25477 13.1323 8.21509 13.1638 8.1654C13.1954 8.1157 13.2122 8.05803 13.2122 7.99915C13.2122 7.94027 13.1954 7.88261 13.1638 7.83291C13.1323 7.78321 13.0872 7.74354 13.0339 7.71852L1.76437 2.19425C1.70709 2.16623 1.64261 2.15639 1.57959 2.16607C1.51657 2.17575 1.45801 2.20448 1.41178 2.24839C1.36556 2.29231 1.33387 2.34932 1.32098 2.41177C1.30809 2.47421 1.31461 2.53911 1.33966 2.59774L3.43888 7.50771C3.50531 7.66286 3.53964 7.82985 3.53979 7.99862C3.53995 8.16739 3.50592 8.33444 3.43977 8.48971L1.33966 13.4006Z",
    stroke: "#3B1F8E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2089 7.99976L3.53962 7.99932",
    stroke: "#3B1F8E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.7cd1c699e1bb3cc384ca54963c9856ba.svg";
export { ForwardRef as ReactComponent };